import classNames from "classnames";
import T from "prop-types";
import React from "react";
import { get } from "lodash";
import {
  DO_NOT_SELL,
  INTERNAL_OUTRIGHT,
  INVENTORY,
  RECLAIMED,
  SELLABLE_STATUS
} from "MODULES/inventories/constants";
import { RECEIVED } from "APP_ROOT/constants";
import {
  APPROVAL_STATUS,
  EXCHANGE,
  EXCHANGE_GONE_OUTRIGHT,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED
} from "MODULES/RepairOrders/constants";
import {
  EXCHANGE_TYPE,
  FLAT_EXCHANGE,
  SECOND_EXCHANGE,
  THIRD_EXCHANGE
} from "MODULES/SalesOrders/constants";
import { dollars } from "LIB/formatters/currency";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { properCase } from "LIB/formatters/text";

export const getCap = lineItem => {
  const doNotSell =
    lineItem.getIn([INVENTORY, SELLABLE_STATUS]) === DO_NOT_SELL;
  return classNames({
    "green-table-cap":
      lineItem.get(APPROVAL_STATUS) === REPAIR_EVALUATION_APPROVED &&
      !lineItem.get(RECEIVED),
    "danger-table-cap": doNotSell && !lineItem.get(RECEIVED),
    "warning-table-cap": !doNotSell && !lineItem.get(RECEIVED)
  });
};

export const getExchange = lineItem =>
  lineItem.get("exchange") && (
    <i className="fa fa-lg fa-check-circle text-success" />
  );

export const totalCost = line =>
  line.approval_status === REPAIR_EVALUATION_REJECTED
    ? line.evaluation_charge
    : line.charges_per_part;

export const totalCostEvalColumn = line => dollars(totalCost(line));

export const extCostEvalColumn = line =>
  dollars(totalCost(line) * Number(line.quantity));

export const totalRepairOrderCost = results =>
  dollars(results.reduce((sum, result) => sum + extCostEvalColumn(result), 0));

export const coreReturnFeeSavingsVal = (doNotExceed, subtotal) =>
  Number(doNotExceed) - Number(parseFloat(subtotal));

export const calculateSubtotal = getField => (fields, val) =>
  fields.reduce((agg, field) => agg + Number(getField(field)), 0) + Number(val);

export const ExchangeIcon = ({ lineItem }) => {
  const exchangeTypes = [
    {
      key: `previous_exchange_details.${EXCHANGE_TYPE}`,
      value: null,
      text: 1,
      hover: properCase(EXCHANGE)
    },
    {
      key: FLAT_EXCHANGE,
      value: true,
      text: "F",
      hover: properCase(FLAT_EXCHANGE)
    },
    {
      key: `previous_exchange_details.${EXCHANGE_TYPE}`,
      value: SECOND_EXCHANGE,
      text: 2,
      hover: properCase(SECOND_EXCHANGE)
    },
    {
      key: `previous_exchange_details.${EXCHANGE_TYPE}`,
      value: THIRD_EXCHANGE,
      text: 3,
      hover: properCase(THIRD_EXCHANGE)
    },
    {
      key: EXCHANGE_GONE_OUTRIGHT,
      value: true,
      text: "O",
      hover: properCase(EXCHANGE_GONE_OUTRIGHT)
    },
    {
      key: INTERNAL_OUTRIGHT,
      value: true,
      text: "io",
      hover: properCase(INTERNAL_OUTRIGHT)
    },
    {
      key: "inventory.reclaimed",
      value: true,
      text: "R",
      hover: properCase(RECLAIMED)
    }
  ];

  const filteredVal = exchangeTypes.filter(
    f => get(lineItem, f.key) === f.value
  );

  if (filteredVal.length === 0) {
    return null;
  }

  const val = filteredVal[filteredVal.length - 1];

  /* eslint react/no-danger: 0 */
  const tooltip = (
    <Tooltip className="in">
      <span dangerouslySetInnerHTML={{ __html: val.hover }} />
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <span className="fa-stack fa-1x">
        <i className="fa fa-lg fa-circle text-success" />
        <span className="fa fa-stack-1x exchange-circle-text">{val.text}</span>
      </span>
    </OverlayTrigger>
  );
};

ExchangeIcon.propTypes = {
  lineItem: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/helpers.jsx